export default __webpack_public_path__ + "static/media/tagIcon.f9b5c4bf.svg";